// The jobs the user opened last, for the Projects page's Continue row. Browser-local, like the frame memory.

export interface RecentJob {
    jobId: number;
    taskId: number;
    referenceId: number | null;
    title: string;
    subtitle: string | null;
    path: string;
    at: number;
}

const KEY = 'cvat-recent-jobs';
export const RECENT_JOBS_LIMIT = 6;

export function readRecentJobs(): RecentJob[] {
    try {
        const parsed = JSON.parse(window.localStorage.getItem(KEY) || '[]');
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((item) => item && Number.isInteger(item.jobId) && typeof item.path === 'string');
    } catch {
        return [];
    }
}

export function rememberRecentJob(entry: Omit<RecentJob, 'at'>): void {
    const rest = readRecentJobs().filter((item) => item.path !== entry.path);
    const next = [{ ...entry, at: Date.now() }, ...rest].slice(0, RECENT_JOBS_LIMIT);
    try {
        window.localStorage.setItem(KEY, JSON.stringify(next));
    } catch {
        // storage blocked: Continue stays as it was
    }
}

export function forgetRecentJob(path: string): void {
    try {
        window.localStorage.setItem(KEY, JSON.stringify(readRecentJobs().filter((item) => item.path !== path)));
    } catch {
        // storage blocked
    }
}
